import axios from 'axios';

const isDev = process.env.NODE_ENV !== 'production';
const debugLog = (...args) => {
  if (isDev) console.log(...args);
};

/**
 * Remove accents and special characters from a string
 * @param {string} str - String to normalize
 * @returns {string} - String without accents
 */
const removeAccents = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

/***
 * Recherche des permis de travaux pour une adresse
 * @param {Object} params Paramètres de recherche
 * @param {string} params.streetNumber Numéro civique
 * @param {string} params.streetName Nom de la rue
 * @param {string} params.year Année de recherche (défaut: 2024)
 * @returns {Promise<Object>} Informations sur les permis
 */
export const searchPermits = async ({ streetNumber, streetName, year = '2024' }) => {
  try {
    const formattedStreetName = removeAccents(streetName.toUpperCase());
    const apiUrlBase = `https://donnees.montreal.ca/api/3/action/datastore_search`;

    const searchPermitsRecursive = async (num, attemptsLeft) => {
      const searchParams = new URLSearchParams();
      searchParams.append('resource_id', '5232a72d-235a-48eb-ae20-bb9d501300ad');
      searchParams.append('q', `${num} ${formattedStreetName}`);

      const displayUrl = `${apiUrlBase}?resource_id=5232a72d-235a-48eb-ae20-bb9d501300ad&q=${num}+${formattedStreetName}`;
      debugLog('Permit API URL:', displayUrl);

      try {
        const response = await axios.get(`${apiUrlBase}?${searchParams.toString()}`);
        debugLog('Permit API raw response:', response.data);
        if (response.data && response.data.success) {
          let records = response.data.result.records || [];
          debugLog(`Total permits found: ${records.length}`);
          let filteredRecords = records;
          if (year) {
            filteredRecords = records.filter(record => record.DATE_PERMIS && record.DATE_PERMIS.includes(year));
            debugLog(`Filtered permits for year ${year}: ${filteredRecords.length}`);
          }
          return {
            success: true,
            count: filteredRecords.length,
            records: filteredRecords,
            allRecords: records,
            apiUrl: displayUrl
          };
        } else if (attemptsLeft > 0) {
          return searchPermitsRecursive(parseInt(num) + 2, attemptsLeft - 1);
        } else {
          return { success: false, error: 'Aucun résultat trouvé après plusieurs tentatives', apiUrl: displayUrl };
        }
      } catch (error) {
        console.error('Erreur lors de la recherche de permis:', error);
        return { success: false, error: error.message || 'Erreur de connexion à l\'API' };
      }
    };

    return await searchPermitsRecursive(streetNumber, 6);

  } catch (error) {
    console.error('Erreur globale lors de la recherche de permis:', error);
    return { success: false, error: error.message || 'Erreur de connexion à l\'API' };
  }
};
